import { render, staticRenderFns } from "./PatientSearchInfectionsRecommendations.vue?vue&type=template&id=61dc2cd5&scoped=true"
import script from "./PatientSearchInfectionsRecommendations.vue?vue&type=script&lang=js"
export * from "./PatientSearchInfectionsRecommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dc2cd5",
  null
  
)

export default component.exports